type StaffJoinResult = {
  found: boolean;
  autoJoined: boolean;
  alreadyMember: boolean;
  orgSlug?: string;
};

export const shouldReloadAfterStaffJoin = (result: StaffJoinResult): boolean =>
  result.found && (result.autoJoined || result.alreadyMember) && !!result.orgSlug;
